export default "__VITE_ASSET__DqKspZ1g__"